if (!customElements.get('product-text-field')) {
  class ProductTextField extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input, textarea');
      this.maxLength = this.dataset.maxLength ? parseInt(this.dataset.maxLength) : null;
      this.counterCurrent = this.querySelector('.product__form-textarea__counter-current, .product__form-text-field__counter-current');

      if (this.input && this.maxLength && this.counterCurrent) {
        this.initCounter();
      }
    }

    initCounter() {
      // Mettre à jour le compteur au chargement
      this.updateCounter();

      // Ajouter un écouteur d'événement pour mettre à jour le compteur lors de la saisie
      this.input.addEventListener('input', () => {
        this.updateCounter();
      });
    }

    updateCounter() {
      const currentLength = this.input.value.length;
      this.counterCurrent.textContent = currentLength;

      // Ajouter une classe si on approche de la limite
      if (currentLength >= this.maxLength * 0.9) {
        this.counterCurrent.classList.add('near-limit');
      } else {
        this.counterCurrent.classList.remove('near-limit');
      }
    }
  }

  customElements.define('product-text-field', ProductTextField);
}
